import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const TILES = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

export const CITY_CENTRES = {
  "cape town": [-33.9249, 18.4241],
  johannesburg: [-26.2041, 28.0473],
  durban: [-29.8587, 31.0218],
  pretoria: [-25.7479, 28.2293],
  "port elizabeth": [-33.9608, 25.6022],
  gqeberha: [-33.9608, 25.6022],
  bloemfontein: [-29.0852, 26.1596],
  "east london": [-33.0153, 27.9116],
  george: [-33.963, 22.4617],
  stellenbosch: [-33.9321, 18.8602],
};

const pinIcon = L.divIcon({
  className: "",
  html: '<div class="tadada-pin tadada-pin-active" style="transform:translate(-50%,-100%)">Pickup here</div>',
  iconSize: [0, 0],
});

function Clicker({ onPick }) {
  useMapEvents({ click: (e) => onPick([e.latlng.lat, e.latlng.lng]) });
  return null;
}

function Recenter({ centre }) {
  const map = useMap();
  useEffect(() => { if (centre) map.setView(centre, map.getZoom() < 11 ? 12 : map.getZoom()); }, [map, centre]);
  return null;
}

/** Click-to-set pickup pin. `value` is [lat, lng] or null; `city` recentres the map when it changes. */
export default function LocationPicker({ value, onChange, city }) {
  const centre = CITY_CENTRES[(city || "").toLowerCase()] || [-29.0, 24.0];
  return (
    <div className="rounded-2xl overflow-hidden border border-[#E2E8F0]" data-testid="location-picker">
      <MapContainer center={value || centre} zoom={value ? 13 : CITY_CENTRES[(city || "").toLowerCase()] ? 12 : 5} className="w-full" style={{ height: 260 }} scrollWheelZoom={false}>
        <TileLayer url={TILES} />
        <Recenter centre={value ? null : centre} />
        <Clicker onPick={onChange} />
        {value && <Marker position={value} icon={pinIcon} draggable eventHandlers={{ dragend: (e) => { const p = e.target.getLatLng(); onChange([p.lat, p.lng]); } }} />}
      </MapContainer>
      <div className="flex items-center justify-between px-4 py-2 text-xs text-[#64748B] bg-[#F7F8FA]">
        <span>{value ? `Pin set: ${value[0].toFixed(4)}, ${value[1].toFixed(4)}` : "Click the map to drop your pickup pin (optional)"}</span>
        {value && <button type="button" onClick={() => onChange(null)} className="font-semibold text-[#1d7ffd]" data-testid="location-picker-clear">Clear</button>}
      </div>
    </div>
  );
}
